var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSearch(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_4148_276)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.3034 14.3401L12.6962 11.7329C14.8766 9.074 14.7248 5.13471 12.2319 2.64364C9.58909 -0.00100454 5.29623 -0.00100454 2.64266 2.64364C-0.0019811 5.29721 -0.0019811 9.59007 2.64266 12.2329C5.13373 14.7258 9.07302 14.8776 11.7319 12.6972L14.3391 15.3044C14.3962 15.3544 14.4873 15.3544 14.5355 15.3044L15.3034 14.5365C15.3534 14.4883 15.3534 14.3972 15.3034 14.3401ZM11.2855 11.2865C9.16409 13.4061 5.72838 13.4061 3.60695 11.2865C1.48731 9.16507 1.48731 5.72935 3.60695 3.60792C5.72838 1.48828 9.16409 1.48828 11.2855 3.60792C13.4052 5.72935 13.4052 9.16507 11.2855 11.2865Z",
    fill: "black",
    fillOpacity: 0.88
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_4148_276"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSearch);
export default __webpack_public_path__ + "static/media/search.609839995089be1f2668838e84dd23dd.svg";
export { ForwardRef as ReactComponent };